<template>
    <div id="toolbar-general-component">
        <v-toolbar :height="is_mobile ? '70px' : '80px'" color="secondary" flat>
            <v-layout class="justify-start">
                <span class="font-20 color-white-fix">{{ title }}</span>
            </v-layout>

            <v-layout v-if="!is_mobile" class="justify-end">
                <div class="nav-grid">
                    <div>
                        <v-icon
                            v-if="$store.getters['user_connected/user_connected'].id_professional === 14"
                            class="pointer"
                            color="primary"
                            size="30"
                            @click="$refs.DialogContactComponent.dialog_contact = true"
                        >
                            mdi-lifebuoy
                        </v-icon>
                    </div>
                    <div class="size-30" @click="navigateTo('notifications')">
                        <v-badge
                            :content="$store.getters['notifications/total_notifications_not_see']"
                            :value="$store.getters['notifications/total_notifications_not_see']"
                            class="badge-lower-size"
                            color="error"
                            light
                            overlap
                        >
                            <v-icon class="mx-auto" color="primary" size="30" @click="navigateTo('notifications')"> mdi-bell </v-icon>
                        </v-badge>
                    </div>
                    <div class="pointer font-20" @click="$refs.profileDialog.dialog_profile = true">
                        <profile-picture-component :width="34" :verify_certified="true" :user="this.$store.getters['user_connected/user_connected']" />
                    </div>

                    <span>
                        <span
                            v-if="$store.getters['user_connected/user_connected'].id_professional === 14"
                            class="font-12 pointer color-white-fix"
                            @click="$refs.DialogContactComponent.dialog_contact = true"
                        >
                            {{ $t('left_navbar_component.assistance') }}
                        </span>
                    </span>
                    <span class="font-12 pointer color-white-fix" @click="navigateTo('notifications')">
                        {{ $t('left_navbar_component.notifications') }}
                    </span>
                    <span class="font-12 pointer color-white-fix" @click="$refs.profileDialog.dialog_profile = true">
                        {{ $t('left_navbar_component.profile') }}
                    </span>
                </div>
            </v-layout>
        </v-toolbar>

        <ProfileDialogComponent ref="profileDialog" />

        <dialog-contact-component ref="DialogContactComponent" />
    </div>
</template>

<script>
import ProfileDialogComponent from '@/components/profile/vision/ProfileDialogComponent.vue'
import DialogContactComponent from '@/components/global/DialogContactComponent.vue'
import ProfilePictureComponent from '@/components/profile/containment/ProfilePictureComponent.vue'

export default {
    name: 'ToolbarComponent',
    components: { ProfilePictureComponent, ProfileDialogComponent, DialogContactComponent },
    data() {
        return {
            asset_types: this.$store.getters['asset_types/asset_types'],
            asset_modules: this.$store.getters['asset_module/asset_modules'],
        }
    },
    props: {
        title: {
            type: String,
            required: true,
        },
    },
}
</script>

<style>
.notification-pin-bell-icon-desktop {
    position: absolute !important;
    top: 10px;
    right: 75px;
}

.badge-notification-toolbar-desktop .v-badge__badge {
    left: 15px !important;
}
</style>
